import { render, staticRenderFns } from "./CallToActions.vue?vue&type=template&id=4b32bdc2&scoped=true"
import script from "./CallToActions.vue?vue&type=script&lang=ts"
export * from "./CallToActions.vue?vue&type=script&lang=ts"
import style0 from "./CallToActions.vue?vue&type=style&index=0&id=4b32bdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32bdc2",
  null
  
)

export default component.exports